export default function mockEinsteinRecommendations(status = '') {
  switch (status) {
    case 'no_recommendation':
      return {
        status: 'no_recommendation'
      };
    case 'no_data':
      return {
        status: 'no_data'
      };
    case 'insufficient_data':
      return {
        status: 'insufficient_data'
      };
    default:
      return {
        undersaturated: Math.floor(Math.random() * 10) + 3,
        oversaturated: Math.floor(Math.random() * 80) + 25,
        expectedGain: Math.random(),
        status: 'ok'
      };
  }
}
